const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDentistry(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 68 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "dentistry"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_60",
    d: "M68,3l0,62c0,1.656 -1.344,3 -3,3l-62,0c-1.656,0 -3,-1.344 -3,-3l0,-62c0,-1.656 1.344,-3 3,-3l62,0c1.656,0 3,1.344 3,3Z",
    style: {
      fill: "#fff",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    d: "M62.735,44.069c-1.958,-0.884 -3.811,-1.986 -5.523,-3.285c-2.08,-1.617 -4.589,-2.588 -7.215,-2.793c-1.427,-0.096 -2.861,-0.007 -4.265,0.265c-3.334,0.596 -6.393,2.239 -8.73,4.69c-0.551,0.601 -1.049,1.249 -1.489,1.936c-0.44,0.687 -7.81,3.126 -10.693,4.819c-1.725,1.038 -2.423,3.216 -1.623,5.064l10.442,-2.459l5.75,-0.351",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    d: "M19.973,53.147l-6.051,-2.707c-1.613,-0.813 -3.531,-2.317 -4.939,-2.236c-0.979,0.041 -1.909,0.44 -2.612,1.122c-0.326,0.327 -0.5,0.645 -0.192,0.8l12.788,7.652c3.07,1.191 6.213,2.185 9.41,2.976c1.563,0.421 3.219,0.349 4.739,-0.207l14.805,-5.4c2.725,-1.329 5.916,-1.329 8.641,-0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    d: "M20.809,49.035l-3.752,-1.69c-1.751,-0.854 -4.028,-2.034 -5.882,-2.951c-0.448,-0.221 -0.935,-0.354 -1.433,-0.39c-0.162,-0.012 -0.332,-0.023 -0.5,-0.033c-0.811,-0.059 -1.613,0.209 -2.226,0.744c-0.053,0.047 -0.1,0.1 -0.152,0.144c-0.177,0.172 -0.277,0.408 -0.277,0.655c0,0.349 0.2,0.668 0.514,0.821l1.967,0.96l1.853,1.459",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    d: "M23.772,46.359l-3.658,-1.615c-7.52,-4.457 -7.979,-1.2 -7.979,-1.2l-0,1.331",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    d: "M35.512,44.88l-7,-1.234l-7.44,-2.741l-0.077,-0.014c-1.697,-0.313 -3.417,0.494 -4.26,2l-0.066,0.117",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    d: "M32.887,7.481l5.042,-0.89c0.367,-0.066 0.74,-0.099 1.113,-0.1l0.009,0c2.248,-0.021 4.344,1.165 5.483,3.103c0.867,1.568 1.304,3.338 1.266,5.13c-0,1.896 -0.495,3.76 -1.436,5.406l-1.443,2.521c-0.688,1.195 -1.108,2.526 -1.23,3.9c-0.276,3.185 -1.246,6.272 -2.84,9.043l-0.96,1.67c-0.245,0.427 -0.701,0.69 -1.193,0.69c-0.755,0 -1.376,-0.621 -1.376,-1.376c-0,0 -0,-2.638 -0,-2.638c-0,-1.344 -0.24,-2.677 -0.708,-3.936l-0.381,-1.025c-0.215,-0.578 -0.77,-0.963 -1.386,-0.963c-0.63,-0 -1.194,0.402 -1.399,0.998l-0.384,1.11c-0.406,1.181 -0.614,2.422 -0.614,3.671c-0,0 0,2.783 0,2.783c0,0.755 -0.621,1.376 -1.376,1.376c-0.492,0 -0.948,-0.263 -1.193,-0.69l-0.96,-1.67c-1.595,-2.773 -2.564,-5.861 -2.839,-9.047c-0.122,-1.374 -0.542,-2.705 -1.23,-3.9l-1.443,-2.521c-0.942,-1.647 -1.438,-3.512 -1.438,-5.409c-0.037,-1.794 0.402,-3.566 1.273,-5.135c1.142,-1.932 3.235,-3.111 5.479,-3.088l0.009,-0c0.373,0.001 0.746,0.034 1.113,0.1l5.042,0.89",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#6dc073",
      strokeWidth: "1.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    d: "M31.825,11.105l-3.05,-0.67c-1.339,-0.316 -2.748,0.132 -3.658,1.163c-0.067,0.075 -0.129,0.154 -0.187,0.238c-0.507,0.726 -0.771,1.593 -0.754,2.478",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#6dc073",
      strokeWidth: "1.6px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentistry);
export default __webpack_public_path__ + "static/media/dentistry.51d5d3f2e3ab662ce9edc00009505c70.svg";
export { ForwardRef as ReactComponent };